<template>
  <modal
    class="editVehicle"
    name="editVehicle"
    transition="pop-out"
    :width="modalWidth"
    :height="650"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.editVehicleModal.title") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $tc("text.editVehicleModal.driver", 2) }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$tc('text.editVehicleModal.driver', 1)"
                    v-model="vehicle.driver"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div style="display: flex; justify-content: flex-start">
                  <label class="required">
                    {{ $tc("text.editVehicleModal.phoneNumber", 2) }}
                  </label>
                </div>
                <div class="input__block" ref="target_input_div">
                  <input
                    style="padding: 20px; width: 100%"
                    type="text"
                    :placeholder="$tc('text.editVehicleModal.phoneNumber', 1)"
                    v-model="vehicle.phoneNo"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $tc("text.editVehicleModal.vehicleType", 2) }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$tc('text.editVehicleModal.vehicleType', 1)"
                      v-model="vehicle.type"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $tc("text.editVehicleModal.carMake", 2) }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$tc('text.editVehicleModal.carMake', 1)"
                      v-model="vehicle.carType"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $tc("text.editVehicleModal.carModel", 2) }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$tc('text.editVehicleModal.carModel', 1)"
                      v-model="vehicle.carModel"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $tc("text.editVehicleModal.modelYear", 2) }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$tc('text.editVehicleModal.modelYear', 1)"
                      v-model="vehicle.carYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $tc("text.editVehicleModal.plateNumber", 2) }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <input
                      style="padding: 20px; width: 100%"
                      type="text"
                      :placeholder="$tc('text.editVehicleModal.plateNumber', 1)"
                      v-model="vehicle.plateNumber"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="editVehicle($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.editVehicleModal.edit") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "editVehicle",
  props: ["vehicle"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeEditVehicleModal() {
      this.$modal.hide("editVehicle");
    },
    editVehicle($event) {
      $event.preventDefault();
      if (!this.vehicle.driver) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.driverMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.phoneNo) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.type) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.vehicleTypeMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.carType) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.carMakeMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.carModel) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.carModelMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.carYear) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.modelYearMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.vehicle.plateNumber) {
        this.$toast.open({
          message: this.$t("text.editVehicleModal.plateNumberMissing"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }
      let companyID;
      if (localStorage.getItem("companyDetails") !== null) {
        companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      }
      let data = this.vehicle;

      this.isButtonDisabled = true;
      $(".loader").show();
      // this.axios
      //   .post(
      //     `${configObject.apiBaseUrl}/Company/RegisterCorporateCustomers/${companyID}`,
      //     data,
      //     configObject.authConfig()
      //   )
      //   .then(() => {
      //     $(".loader").hide();
      //     this.isButtonDisabled = false;
      //     this.closeEditVehicleModal();
      //     this.$toast.open({
      //       message: this.$t('text.editVehicleModal.successfullyEdited'),
      //       type: "success",
      //       duration: 10000
      //     });
      //     this.$eventHub.$emit("getVehicles");
      //     data = null;
      //     this.vehicle = {
      //       driver: '',
      //       phoneNo: '',
      //       type: '',
      //       carType: '',
      //       carModel: '',
      //       carYear: '',
      //       plateNumber: ''
      //     }
      //   })
      //   .catch(error => {
      //     this.isButtonDisabled = false;
      //     $(".loader").hide();
      //     this.$toast.open({
      //       message: error.response.data.message,
      //       type: "error",
      //       duration: 5000
      //     });
      //   });
    },
  },
};
</script>
